'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const XLSIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="XLSIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        id="Google-Sheets-Logo--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Google Sheets Logo Streamline Icon: https://streamlinehq.com</desc>
        <g>
          <path
            d="M21.5 21.5a2 2 0 0 1 -2 2h-15a2 2 0 0 1 -2 -2v-19a2 2 0 0 1 2 -2H15L21.5 7Z"
            fill="none"
            stroke={sx?.color || '#3d517b8f'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          ></path>
          <path
            d="M21.5 7H17a2 2 0 0 1 -2 -2V0.5Z"
            fill="none"
            stroke={sx?.color || '#3d517b8f'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          ></path>
          <path
            d="M6.66 10.5h10.69V20H6.66Z"
            fill="none"
            stroke={sx?.color || '#3d517b8f'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          ></path>
          <path
            d="m6.66 13.67 10.68 0"
            fill="none"
            stroke={sx?.color || '#3d517b8f'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          ></path>
          <path
            d="m6.66 16.83 10.68 0"
            fill="none"
            stroke={sx?.color || '#3d517b8f'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          ></path>
          <path
            d="m12 10.5 0 9.5"
            fill="none"
            stroke={sx?.color || '#3d517b8f'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  )
}

XLSIcon.propTypes = {
  sx: PropTypes.object
}
